module.exports = __webpack_public_path__ + "media/images/hero/glyph-1-192ef9d68bbc3561c8b0e091b52712c6.svg";